import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PostalCodeInput from '../../ui/address-input/postal-code-input';
import { TextField } from '../../ui/text-field';
import JapanPostalCodeMark from './japan-postal-code-mark';
const JapanPostalCode = _ref => {
  let {
    autocomplete,
    ...props
  } = _ref;
  const prefix = /*#__PURE__*/React.createElement(JapanPostalCodeMark, null);
  return autocomplete ? /*#__PURE__*/React.createElement(PostalCodeInput, _extends({}, props, {
    prefix: prefix
  })) : /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    prefix: prefix
  }));
};
export default JapanPostalCode;
//# sourceMappingURL=japan-postal-code.js.map